import type { ReactElement } from 'react';
import { ApiFeil } from '../api/klient.js';

/**
 * Loading announcement.
 *
 * `role="status"` (an implicit aria-live="polite" region) is what tells a screen
 * reader user that something is happening. Without it, a spinner is a purely
 * visual event and the page simply appears to do nothing.
 */
export function Laster({ hva }: { hva: string }): ReactElement {
  return (
    <p role="status" className="text-sm text-tekst-dempet">
      Laster {hva} …
    </p>
  );
}

/**
 * Error display.
 *
 * `role="alert"` so it is announced immediately, and the trace id is shown when
 * the API supplied one: it is the value that finds this exact request in the
 * server logs, which turns "it didn't work" into a supportable report.
 */
export function Feilmelding({ feil }: { feil: unknown }): ReactElement {
  const melding = feil instanceof ApiFeil ? feil.brukermelding : 'Noe gikk galt. Prøv igjen.';
  const sporingsId = feil instanceof ApiFeil ? feil.sporingsId : null;

  return (
    <div role="alert" className="rounded-md border border-negativ/40 bg-negativ-svak p-4">
      <p className="text-sm font-medium text-negativ">{melding}</p>
      {sporingsId ? (
        <p className="mt-1 text-xs text-tekst-dempet">
          Sporings-ID: <code>{sporingsId}</code>
        </p>
      ) : null}
    </div>
  );
}
